import React from 'react';

import classNames from 'classnames';
import { Icon } from 'src/components/Atoms/Icon/Icon';
import styles from './TabNavigation.module.scss';
import { useTabNavigation } from './useTabNavigation';

export function TabNavigation() {
  const {
    sectionTitles,
    navigationMode,
    sectionNavigationMode,
    activeTab,
    onTabClick,
    tabNavigationRef,
    isOverflowing,
    scrollLeft,
    scrollRight,
    canScrollLeft,
    canScrollRight,
    stickyTop,
  } = useTabNavigation();

  if (sectionNavigationMode === 'none' || sectionTitles.length <= 1) {
    return null;
  }

  const tabNavigationStyle = {
    top: stickyTop,
  };

  return (
    <nav id="tabNavigation" className={styles.tabNavigationSticky} style={tabNavigationStyle}>
      {isOverflowing && (
        <button type="button" className={styles.tabNavigationLeft} onClick={scrollLeft} disabled={!canScrollLeft}>
          <Icon name="chevron-left" />
        </button>
      )}
      <div ref={tabNavigationRef} className={styles.tabNavigation}>
        {sectionTitles.map((tab) => (
          <a
            href={`#${tab.slug}`}
            className={classNames(styles.tabItem, { [styles.active]: activeTab === tab.slug })}
            key={tab.id}
            onClick={(event) => {
              if (navigationMode === 'tabs') {
                event.preventDefault();
              }
              onTabClick(tab.slug);
            }}
          >
            {tab.title}
          </a>
        ))}
      </div>
      {isOverflowing && (
        <button type="button" className={styles.tabNavigationRight} onClick={scrollRight} disabled={!canScrollRight}>
          <Icon name="chevron-right" />
        </button>
      )}
    </nav>
  );
}
